import React, { useEffect, useState } from 'react';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Sidebar from './Sidebar';
import Swal from 'sweetalert2';
import { getAllFaqs, createFaq, updateFaq, deleteFaq } from '../api/auth/faqService';

function FAQSupdate() {
  const [data, setData] = useState([]);
  const [values, setValues] = useState({
    question: '',
    answer: '',
    date: ''
  });
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const faqs = await getAllFaqs();
      setData(faqs);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleChanges = (e) => {
    const { name, value } = e.target;
    setValues(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const currentDate = new Date().toISOString().split('T')[0];

    const payload = {
      ...values,
      date: currentDate
    };

    try {
      if (editingId) {
        await updateFaq(editingId, payload);
        Swal.fire('Updated!', 'FAQ has been updated.', 'success');
        setEditingId(null);
      } else {
        await createFaq(payload);
        Swal.fire('Success', 'FAQ created successfully.', 'success');
      }
      fetchData();
      setValues({ question: '', answer: '', date: '' });
    } catch (error) {
      Swal.fire('Error', editingId ? 'Update failed.' : 'Failed to create FAQ.', 'error');
    }
  };

  const handleEditClick = (item) => {
    setValues({
      question: item.question,
      answer: item.answer,
      date: item.date || ''
    });
    setEditingId(item.id);
  };

  const handleDelete = async (id) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this entry!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await deleteFaq(id);
          setData(prev => prev.filter(item => item.id !== id));
          Swal.fire('Deleted!', 'The FAQ has been deleted.', 'success');
        } catch (error) {
          Swal.fire('Error!', 'There was a problem deleting the FAQ.', 'error');
          console.error('Error deleting FAQ:', error);
        }
      }
    });
  };

  return (
    <div>
      <Sidebar />
      <div className="col-md-9 px-4" style={{ marginLeft: '200px' }}>
        <div className="container-fluid">
          <div className="row mt-4">
            <div className="col-md-12">
              <h5 className="page-title">FAQs Update</h5>
            </div>
          </div>

          {/* Form */}
          <div className="row mt-3">
            <div className="col-md-8">
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label">FAQs Question</label>
                  <input
                    type="text"
                    className="form-control"
                    name="question"
                    placeholder="Enter Question"
                    onChange={handleChanges}
                    value={values.question}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Answer</label>
                  <textarea
                    className="form-control"
                    name="answer"
                    placeholder="Enter Answer"
                    onChange={handleChanges}
                    value={values.answer}
                    required
                  />
                </div>

                <button type="submit" className="btn btn-primary">
                  {editingId ? 'Update FAQ' : 'Add FAQ'}
                </button>
                {editingId && (
                  <button
                    type="button"
                    className="btn btn-secondary ms-2"
                    onClick={() => {
                      setEditingId(null);
                      setValues({ question: '', answer: '', date: '' });
                    }}
                  >
                    Cancel
                  </button>
                )}
              </form>
            </div>
          </div>

          {/* Table */}
          <div className="row mt-3">
            <div className="col-md-12">
              <table className="table table-bordered">
                <thead className="table-primary">
                  <tr>
                    <th>#</th>
                    <th>Question</th>
                    <th>Answer</th>
                    <th>Date</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((item, index) => (
                    <tr key={item.id}>
                      <td>{index + 1}</td>
                      <td>{item.question}</td>
                      <td>{item.answer}</td>
                      <td>{item.date || 'N/A'}</td>
                      <td style={{width:'15%'}}>
                        <button className="btn btn-primary me-2" onClick={() => handleEditClick(item)}>Edit</button>
                        <button className="btn btn-danger" onClick={() => handleDelete(item.id)}>Delete</button>
                      </td>
                    </tr>
                  ))}
                  {data.length === 0 && (
                    <tr>
                      <td colSpan="5" className="text-center">No FAQs found.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FAQSupdate;